import React from 'react';
import {useState,useEffect,Component} from 'react';
import { useNavigate } from 'react-router-dom';
import { BrowserRouter as Router,Routes,Route,Link} from 'react-router-dom';

import './Resources/dashboard.css';
import axios from './../axios.js';
import Navbar from './Supportingfiles/navbar';
import Sidebar from './Supportingfiles/sidebar';
//import edit_loanrequests from './edit_newaccounts';



function Employee_edit_cash(){

 //Checking Sessions
 // Access value associated with the login status
 const logstatus=sessionStorage.getItem("logStatus00");
 const logid=sessionStorage.getItem("logId00");
 const token=sessionStorage.getItem("logToken00");
 const logname=sessionStorage.getItem("logName00");
 const editId=sessionStorage.getItem("EditId00");
 const branch_id=sessionStorage.getItem("branchId00");
 

 useEffect(()=>{
   
  getData();
  
  },[])
 


  //SETTING DATA VARIABLES
  const[date,setdate]=useState();const updatedate = (event) => { setdate(event.target.value);}; const[date_er,setdate_er]=useState();
  const[transaction,settransaction]=useState();const updatetransaction = (event) => { settransaction(event.target.value);}; const[transaction_er,settransaction_er]=useState();
  const[particular,setparticular]=useState();const updateparticular = (event) => { setparticular(event.target.value);}; const[particular_er,setparticular_er]=useState();
  const[amount,setamount]=useState();const updateamount = (event) => { setamount(event.target.value);}; const[amount_er,setamount_er]=useState();

    //currency counts
    const[ec2000_in,setec2000_in]=useState(0);const updateec2000_in = (event) => { setec2000_in(event.target.value); /* handlecurrency(); */ }; const[ec2000_in_er,setec2000_in_er]=useState();
    const[ec500_in,setec500_in]=useState(0);const updateec500_in = (event) => { setec500_in(event.target.value); /* handlecurrency(); */ }; const[ec500_in_er,setec500_in_er]=useState();
    const[ec200_in,setec200_in]=useState(0);const updateec200_in = (event) => { setec200_in(event.target.value); /* handlecurrency(); */ }; const[ec200_in_er,setec200_in_er]=useState();
    const[ec100_in,setec100_in]=useState(0);const updateec100_in = (event) => { setec100_in(event.target.value); /* handlecurrency(); */ }; const[ec100_in_er,setec100_in_er]=useState();
    const[ec50_in,setec50_in]=useState(0);const updateec50_in = (event) => { setec50_in(event.target.value); /* handlecurrency(); */ }; const[ec50_in_er,setec50_in_er]=useState();
    const[ec20_in,setec20_in]=useState(0);const updateec20_in = (event) => { setec20_in(event.target.value);  /* handlecurrency(); */ }; const[ec20_in_er,setec20_in_er]=useState();
    const[ec10_in,setec10_in]=useState(0);const updateec10_in = (event) => { setec10_in(event.target.value); /* handlecurrency(); */ }; const[ec10_in_er,setec10_in_er]=useState();
    const[ec5_in,setec5_in]=useState(0);const updateec5_in = (event) => { setec5_in(event.target.value); /* handlecurrency(); */ }; const[ec5_in_er,setec5_in_er]=useState();
    const[ec2_in,setec2_in]=useState(0);const updateec2_in = (event) => { setec2_in(event.target.value); /* handlecurrency(); */ }; const[ec2_in_er,setec2_in_er]=useState();
    const[ec1_in,setec1_in]=useState(0);const updateec1_in = (event) => { setec1_in(event.target.value); /* handlecurrency(); */ }; const[ec1_in_er,setec1_in_er]=useState();
    const[ec2000_out,setec2000_out]=useState(0);const updateec2000_out = (event) => { setec2000_out(event.target.value); /* handlecurrency(); */ }; const[ec2000_out_er,setec2000_out_er]=useState();
    const[ec500_out,setec500_out]=useState(0);const updateec500_out = (event) => { setec500_out(event.target.value); /* handlecurrency(); */ }; const[ec500_out_er,setec500_out_er]=useState();
    const[ec200_out,setec200_out]=useState(0);const updateec200_out = (event) => { setec200_out(event.target.value); /* handlecurrency(); */ }; const[ec200_out_er,setec200_out_er]=useState();
    const[ec100_out,setec100_out]=useState(0);const updateec100_out = (event) => { setec100_out(event.target.value); /* handlecurrency(); */ }; const[ec100_out_er,setec100_out_er]=useState();
    const[ec50_out,setec50_out]=useState(0);const updateec50_out = (event) => { setec50_out(event.target.value); /* handlecurrency(); */ }; const[ec50_out_er,setec50_out_er]=useState();
    const[ec20_out,setec20_out]=useState(0);const updateec20_out = (event) => { setec20_out(event.target.value); /* handlecurrency(); */ }; const[ec20_out_er,setec20_out_er]=useState();
    const[ec10_out,setec10_out]=useState(0);const updateec10_out = (event) => { setec10_out(event.target.value); /* handlecurrency(); */ }; const[ec10_out_er,setec10_out_er]=useState();
    const[ec5_out,setec5_out]=useState(0);const updateec5_out = (event) => { setec5_out(event.target.value); /* handlecurrency(); */ }; const[ec5_out_er,setec5_out_er]=useState();
    const[ec2_out,setec2_out]=useState(0);const updateec2_out = (event) => { setec2_out(event.target.value); /* handlecurrency(); */ }; const[ec2_out_er,setec2_out_er]=useState();
    const[ec1_out,setec1_out]=useState(0);const updateec1_out = (event) => { setec1_out(event.target.value); /* handlecurrency(); */ }; const[ec1_out_er,setec1_out_er]=useState();
  
    const[ccount_in,setccount_in]=useState(0);const updateccount_in = (event) => { setccount_in(event.target.value);}; const[ccount_in_er,setccount_in_er]=useState();
    const[ccount_out,setccount_out]=useState(0);const updateccount_out = (event) => { setccount_out(event.target.value);}; const[ccount_out_er,setccount_out_er]=useState();
    const[ctotal_in,setctotal_in]=useState(0);const updatectotal_in = (event) => { setctotal_in(event.target.value);}; const[ctotal_in_er,setctotal_in_er]=useState();
    const[ctotal_out,setctotal_out]=useState(0);const updatectotal_out = (event) => { setctotal_out(event.target.value);}; const[ctotal_out_er,setctotal_out_er]=useState();
    const[camount,setcamount]=useState(0);const updatecamount = (event) => { setcamount(event.target.value);}; const[camount_er,setcamount_er]=useState();

  
 //ERROR VARIABLES 
 const[error_msg,seterror_msg]=useState();

 //image upload
 //File Upload
 const [selectedFile, setSelectedFile] = React.useState(null);
 const handleFileChange = (event) => {  const file = event.target.files[0];  setSelectedFile(file); };

 
 const[attachment_link_er,setattachment_link_er]=useState();


 

 useEffect(()=>{
   
  handlecurrency();
  
  },[
  ec2000_in, ec500_in, ec200_in, ec100_in, ec50_in, ec20_in, ec10_in, ec5_in, ec2_in, ec1_in,
  ec2000_out, ec500_out, ec200_out, ec100_out, ec50_out, ec20_out, ec10_out, ec5_out, ec2_out, ec1_out
  ])

 //handle currency function
 function handlecurrency(){

  //currency count
  const $ec2000_in = parseInt(ec2000_in) || 0;
  const $ec500_in = parseInt(ec500_in) || 0;
  const $ec200_in = parseInt(ec200_in) || 0;
  const $ec100_in = parseInt(ec100_in) || 0;
  const $ec50_in = parseInt(ec50_in) || 0;
  const $ec20_in = parseInt(ec20_in) || 0;
  const $ec10_in = parseInt(ec10_in) || 0;
  const $ec5_in = parseInt(ec5_in) || 0;
  const $ec2_in = parseInt(ec2_in) || 0;
  const $ec1_in = parseInt(ec1_in) || 0;
  const $ec2000_out = parseInt(ec2000_out) || 0;
  const $ec500_out = parseInt(ec500_out) || 0;
  const $ec200_out = parseInt(ec200_out) || 0;
  const $ec100_out = parseInt(ec100_out) || 0;
  const $ec50_out = parseInt(ec50_out) || 0;
  const $ec20_out = parseInt(ec20_out) || 0;
  const $ec10_out = parseInt(ec10_out) || 0;
  const $ec5_out = parseInt(ec5_out) || 0;
  const $ec2_out = parseInt(ec2_out) || 0;
  const $ec1_out = parseInt(ec1_out) || 0;

  const $ccount_in = $ec2000_in + $ec500_in + $ec200_in + $ec100_in + $ec50_in + $ec20_in + $ec10_in + $ec5_in + $ec2_in + $ec1_in;
  const $ccount_out = $ec2000_out + $ec500_out + $ec200_out + $ec100_out + $ec50_out + $ec20_out + $ec10_out + $ec5_out + $ec2_out + $ec1_out;

  const $ctotal_in = ($ec2000_in * 2000) + ($ec500_in * 500) + ($ec200_in * 200) + ($ec100_in * 100) + ($ec50_in * 50) + ($ec20_in * 20) + ($ec10_in * 10) + ($ec5_in * 5) + ($ec2_in * 2) + ($ec1_in * 1);
  const $ctotal_out = ($ec2000_out * 2000) + ($ec500_out * 500) + ($ec200_out * 200) + ($ec100_out * 100) + ($ec50_out * 50) + ($ec20_out * 20) + ($ec10_out * 10) + ($ec5_out * 5) + ($ec2_out * 2) + ($ec1_out * 1);

  const $camount = $ctotal_in - $ctotal_out;

setccount_in($ccount_in);
setccount_out($ccount_out);
setctotal_in($ctotal_in);
setctotal_out($ctotal_out);
setcamount($camount);


 }
 

//******************* GET TRANSACTION DATA FUNCTION START  ********************//
function getData(){
 

  //Checking if user loggedin
  if(((logstatus!=null)||(logstatus!=""))&&((logid!=null)||(logid!=""))&&((token!=null)||(token!=" "))&&(editId>0)&&(branch_id)){
 
 axios.post("crm-employee-get-cash-transaction-details-by-id", {
   Log_id:logid,
   Token:token,
   Edit_id:editId,
   Branch_id:branch_id


   })
 .then((response) => {

  //Invalid Session
  if((response.data.error)==100){ 
      //Remove Session Variables and redirect to login
     sessionStorage.removeItem("logStatus00");
     sessionStorage.removeItem("logId00");
     sessionStorage.removeItem("logToken00");
     sessionStorage.removeItem("logName00");
     sessionStorage.removeItem("EditId00");
     window.location.replace("/");
  }

  //Data Not Found
  if((response.data.error)==103){  seterror_msg("Data Not Found for Transaction No. !");}

  //Success Data Fetched
  if(response.data.successvar==1){
   //Setting Data
   setdate(response.data.date);
   settransaction(response.data.transaction);
   setparticular(response.data.particular);
   setamount(response.data.amount);
   
   setec2000_in(response.data.c2000_in);
   setec500_in(response.data.c500_in);
   setec200_in(response.data.c200_in);
   setec100_in(response.data.c100_in);
   setec50_in(response.data.c50_in);
   setec20_in(response.data.c20_in);
   setec10_in(response.data.c10_in);
   setec5_in(response.data.c5_in);
   setec2_in(response.data.c2_in);
   setec1_in(response.data.c1_in);
   setec2000_out(response.data.c2000_out);
   setec500_out(response.data.c500_out);
   setec200_out(response.data.c200_out);
   setec100_out(response.data.c100_out);
   setec50_out(response.data.c50_out);
   setec20_out(response.data.c20_out);
   setec10_out(response.data.c10_out);
   setec5_out(response.data.c5_out);
   setec2_out(response.data.c2_out);
   setec1_out(response.data.c1_out);
   setccount_in(response.data.ccount_in);
   setccount_out(response.data.ccount_out);
   setctotal_in(response.data.ctotal_in);
   setctotal_out(response.data.ctotal_out);
   setcamount(response.data.camount);
   
  }

  //FILTER DATA
  //Validation Errors
  if(response.data.validatorerror){ seterror_msg("Validation error!"); }

  //Data Violation
  if(response.data.error==102){  seterror_msg("Violation Error"); }

 
 
 });
 
 }
 //User not Logedin
 else{
 
 //Remove Session Variables and redirect to login
   sessionStorage.removeItem("logStatus00");
   sessionStorage.removeItem("logId00");
   sessionStorage.removeItem("logToken00");
   sessionStorage.removeItem("logName00");
   sessionStorage.removeItem("EditId00");
   window.location.replace("/");
 
  }
 
 }
  
 //******************* GET TRANSACTION DATA FUNCTION END  ********************//



 
 
/***************** EDIT TRANSACTION FUNCTION START  ******************/
function edit_transaction(){

  
  //Checking if user loggedin
  if(((logstatus!=null)||(logstatus!=""))&&((logid!=null)||(logid!=""))&&((token!=null)||(token!=" "))&&((logname!=null)||(logname!=" "))&&(editId>0)&&(branch_id>0)){


    //Setting Error Variables
    setdate_er(" ");settransaction_er(" ");setparticular_er(" ");setamount_er(" ");seterror_msg(" ");
    setec2000_in_er(" "); setec500_in_er(" "); setec200_in_er(" "); setec100_in_er(" "); setec50_in_er(" "); setec20_in_er(" "); setec10_in_er(" "); setec5_in_er(" "); setec2_in_er(" "); setec1_in_er(" ");
    setec2000_out_er(" "); setec500_out_er(" "); setec200_out_er(" "); setec100_out_er(" "); setec50_out_er(" "); setec20_out_er(" "); setec10_out_er(" "); setec5_out_er(" "); setec2_out_er(" "); setec1_in_er(" ");

    
//Fetching Form Data
let noerror = 0;
const $date = document.getElementById("date").value; if($date==""){ setdate_er("Date is required !");noerror = noerror+1; }//date
const $transaction = document.getElementById("transaction").value; if($transaction==""){ settransaction_er("Transaction is required !");noerror = noerror+1; }//transaction
const $particular = document.getElementById("particular").value; if($particular==""){ setparticular_er("Particular is required !");noerror = noerror+1; }//particular
const $amount = document.getElementById("amount").value; if($amount==""){ setamount_er("Amount is required !");noerror = noerror+1; }//amount


//currency count
const $ec2000_in = document.getElementById("ec2000_in").value;
const $ec500_in = document.getElementById("ec500_in").value;
const $ec200_in = document.getElementById("ec200_in").value;
const $ec100_in = document.getElementById("ec100_in").value;
const $ec50_in = document.getElementById("ec50_in").value;
const $ec20_in = document.getElementById("ec20_in").value;
const $ec10_in = document.getElementById("ec10_in").value;
const $ec5_in = document.getElementById("ec5_in").value;
const $ec2_in = document.getElementById("ec2_in").value;
const $ec1_in = document.getElementById("ec1_in").value;
const $ec2000_out = document.getElementById("ec2000_out").value;
const $ec500_out = document.getElementById("ec500_out").value;
const $ec200_out = document.getElementById("ec200_out").value;
const $ec100_out = document.getElementById("ec100_out").value;
const $ec50_out = document.getElementById("ec50_out").value;
const $ec20_out = document.getElementById("ec20_out").value;
const $ec10_out = document.getElementById("ec10_out").value;
const $ec5_out = document.getElementById("ec5_out").value;
const $ec2_out = document.getElementById("ec2_out").value;
const $ec1_out = document.getElementById("ec1_out").value;


if($amount != camount){
  seterror_msg("Currency Amount Do Not Match the Amount !"); return;
}

//No primary errors
if(noerror==0){


  //Sending Data through axios
  axios.post("crm-employee-edit-cash-transaction-details", { 
  Log_id:logid,
  Token:token,
  Date:$date,
  Transaction:$transaction,
  Particular:$particular,
  Amount:$amount,
  File_attachment:selectedFile,
  Edit_id:editId,
  Branch_id:branch_id,

  //currency count
  C2000_in:$ec2000_in,
  C500_in:$ec500_in,
  C200_in:$ec200_in,
  C100_in:$ec100_in,
  C50_in:$ec50_in,
  C20_in:$ec20_in,
  C10_in:$ec10_in,
  C5_in:$ec5_in,
  C2_in:$ec2_in,
  C1_in:$ec1_in,
  C2000_out:$ec2000_out,
  C500_out:$ec500_out,
  C200_out:$ec200_out,
  C100_out:$ec100_out,
  C50_out:$ec50_out,
  C20_out:$ec20_out,
  C10_out:$ec10_out,
  C5_out:$ec5_out,
  C2_out:$ec2_out,
  C1_out:$ec1_out,

 
  },{
    headers: { "Content-Type": "multipart/form-data" },
    }
    )
  
  .then((response) => {

  //Validation Errors
  if(response.data.validatorerror){
  setdate_er(response.data.validatorerror.Date);
  settransaction_er(response.data.validatorerror.Transaction);
  setparticular_er(response.data.validatorerror.Particular);
  setamount_er(response.data.validatorerror.Amount);
  setattachment_link_er(response.data.validatorerror.File_attachment);
  
  setec2000_in_er(response.data.validatorerror.C2000_in);
  setec500_in_er(response.data.validatorerror.C500_in);
  setec200_in_er(response.data.validatorerror.C200_in);
  setec100_in_er(response.data.validatorerror.C100_in);
  setec50_in_er(response.data.validatorerror.C50_in);
  setec20_in_er(response.data.validatorerror.C20_in);
  setec10_in_er(response.data.validatorerror.C10_in);
  setec5_in_er(response.data.validatorerror.C5_in);
  setec2_in_er(response.data.validatorerror.C2_in);
  setec1_in_er(response.data.validatorerror.C1_in);
  setec2000_out_er(response.data.validatorerror.C2000_out);
  setec500_out_er(response.data.validatorerror.C500_out);
  setec200_out_er(response.data.validatorerror.C200_out);
  setec100_out_er(response.data.validatorerror.C100_out);
  setec50_out_er(response.data.validatorerror.C50_out);
  setec20_out_er(response.data.validatorerror.C20_out);
  setec10_out_er(response.data.validatorerror.C10_out);
  setec5_out_er(response.data.validatorerror.C5_out);
  setec2_out_er(response.data.validatorerror.C2_out);
  setec1_out_er(response.data.validatorerror.C1_out);
  seterror_msg("Cannot Update Transaction !");
  
  
  }
  //Invalid Entries
  if(response.data.error==102){ 

  setdate_er(response.data.date_er);
  settransaction_er(response.data.transaction_er);
  setparticular_er(response.data.particular_er);
  setamount_er(response.data.amount_er);
  
  setec2000_in_er(response.data.c2000_in_er);
  setec500_in_er(response.data.c500_in_er);
  setec200_in_er(response.data.c200_in_er);
  setec100_in_er(response.data.c100_in_er);
  setec50_in_er(response.data.c50_in_er);
  setec20_in_er(response.data.c20_in_er);
  setec10_in_er(response.data.c10_in_er);
  setec5_in_er(response.data.c5_in_er);
  setec2_in_er(response.data.c2_in_er);
  setec1_in_er(response.data.c1_in_er);
  setec2000_out_er(response.data.c2000_out_er);
  setec500_out_er(response.data.c500_out_er);
  setec200_out_er(response.data.c200_out_er);
  setec100_out_er(response.data.c100_out_er);
  setec50_out_er(response.data.c50_out_er);
  setec20_out_er(response.data.c20_out_er);
  setec10_out_er(response.data.c10_out_er);
  setec5_out_er(response.data.c5_out_er);
  setec2_out_er(response.data.c2_out_er);
  setec1_out_er(response.data.c1_out_er);
  seterror_msg("Cannot Update Transaction !");
  
  
  }
  
  //Branch Name or Branch Code Already Exists
  if(response.data.error==103){  seterror_msg(response.data.error_msg); return; }
  
  //Success
  if(response.data.successvar==1){ document.getElementById("success-card").style.display="block"; }

  //failure
  if(response.data.successvar==6){ seterror_msg("Cannot Update Transaction !"); }

  //Session Expired
  if(response.data.successvar==100){ seterror_msg("Session Expired !");  }


  }    );
  
  }
  

  }
  //User not Logedin
 else{
 
 //Remove Session Variables and redirect to login
 sessionStorage.removeItem("logStatus00");
 sessionStorage.removeItem("logId00");
 sessionStorage.removeItem("logToken00");
 sessionStorage.removeItem("logName00");
 
 window.location.replace("/");
 
 
 }    

}

/***************** EDIT TRANSACTION FUNCTION END  ******************/


return(
    <>

<html lang="en">
  <head>
    {/*} Required meta tags */}
    <meta charset="utf-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
    <title>Pragati Prathmik Sakh Sahkari Samiti Maryadit | Employee Dashboard</title>
    {/*} plugins:css */}
    <link rel="stylesheet" href="panel/assets/vendors/mdi/css/materialdesignicons.min.css" />
    <link rel="stylesheet" href="panel/assets/vendors/flag-icon-css/css/flag-icon.min.css" />
    <link rel="stylesheet" href="panel/assets/vendors/css/vendor.bundle.base.css" />
    {/*} endinject */}
    {/*} Plugin css for this page */}
    <link rel="stylesheet" href="panel/assets/vendors/jquery-bar-rating/css-stars.css" />
    <link rel="stylesheet" href="panel/assets/vendors/font-awesome/css/font-awesome.min.css" />
    {/*} End plugin css for this page */}
    {/*} inject:css */}
    {/*} endinject */}
    {/*} Layout styles */}
    <link rel="stylesheet" href="panel/assets/css/demo_1/style.css" />
    {/*} End layout styles */}
    <link rel="shortcut icon" href="panel/assets/images/favicon.png" />
  </head>
  <body>
    <div className="container-scroller">

   {/*}   <Sidebar /> */}
    <div className="container-fluid page-body-wrapper">


       <Navbar />
        {/*} partial */}
        <div className="main-panel">

        

          <div className="content-wrapper pb-0">

          

                 {/*  SUCCESS CARD START */}
                 <div class="d-flex justify-content-center">
               <div class="col-md-6 grid-margin stretch-card" style={{position:"fixed",zIndex:"3",marginTop:"4rem",display:"none"}} id="success-card">
                <div class="card">
                  <div class="card-body">
                    <h4 class="card-title  text-success">Transaction Updated Successfully !!!</h4>
                  
                    <blockquote class="blockquote">
                      <p class="mb-0"> Click the following button to continue.</p>
                      <a href="employee-dashboard-cash"><button class="mt-3 btn btn-outline-success">Continue</button></a>
                    </blockquote>
                  </div>
              
                </div>
              </div>
              </div>
              {/*  SUCCESS CARD END */}


          <div className="page-header flex-wrap">
            <div className="header-left"></div>
              <div className="header-right d-flex flex-wrap mt-2 mt-sm-0">
                <div className="d-flex align-items-center">
                  <a href="#">
                    <p className="m-0 pe-3">EMPLOYEE PANEL</p>
                  </a>
                  <a className="ps-3 me-4" href="#">
                    <p className="m-0">EDIT CASH TRANSACTION</p>
                  </a>

                </div>
          {/*}     <button type="button" className="btn btn-primary mt-2 mt-sm-0 btn-icon-text"  onClick={()=>{ 
               const createForm = document.getElementById('create-form');
               const currentDisplay = createForm.style.display;
               createForm.style.display = currentDisplay === 'none' ? 'block' : 'none'; }}>
                  <i className="mdi mdi-plus-circle"></i>New Loan Request</button>  */}
              </div>
            </div>


                <div class="card">
              
                  <div class="card-body" style={{textAlign:"left"}}>
                    <h4 class="card-title">Edit Transaction</h4>
                    <div class="form-sample">
                      <p class="card-description">edit cash transaction</p>
                      <code>{error_msg}</code>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Date</label>
                            <div class="col-sm-9">
                              <input type="date" class="form-control" id="date" value={date} onChange={updatedate} />
                              <code>{date_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Transaction</label>
                            <div class="col-sm-9">
                            <select class="form-control" style={{padding:"1rem"}} id="transaction" value={transaction} onChange={updatetransaction}>
                            <option value=""> -- Select Transaction -- </option>
                            <option value="entry"> entry </option>
                            <option value="drawings"> drawings </option>
                            </select>
                            <code>{transaction_er}</code>
                            </div>
                          </div>
                        </div>   
                        </div>
                        <div class="form-group">
                        <label for="exampleTextarea1">Particular</label>
                        <textarea  class="form-control" rows="2" placeholder="here particular" id="particular" value={particular} onChange={updateparticular} />
                        <code>{particular_er}</code>
                        </div>

                        <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Amount</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="5000.00" id="amount" value={amount} onChange={updateamount} />
                              <code>{amount_er}</code>
                            </div>
                          </div>
                        </div>   
                        </div>

                        <div class="col-md-12">
                          <div class="form-group row">
                            <label class="col-sm-4 col-form-label">Attachment</label>
                            <div class="col-sm-3">
                              <input type="file" class="form-control"  id="logo_link"  onChange={handleFileChange} multiple />
                              {selectedFile && <p>Selected file: {selectedFile.name}</p>}
                              <code>{attachment_link_er}</code>
                           
                            </div>
                          <div class="col-sm-5">
                          <p>Allowed File format (.png, .jpg), Max. file Size Allowed 1mb. </p>
                          </div>
                        </div>
                      </div>

                       <h3 style={{textAlign:"left", marginTop:"2rem"}}>Currency/ Denomination</h3>
                        {/* CURRENCY ENTRY TABLE START */}
                        <div class="row">
                          <h6  style={{textAlign:"left", marginTop:"2rem"}}>Currency Entry</h6>
                          <table class="table table-bordered">
                            <thead>
                              <th>2000</th>
                              <th>500</th>
                              <th>200</th>
                              <th>100</th>
                              <th>50</th>
                              <th>20</th>
                              <th>10</th>
                              <th>5</th>
                              <th>2</th>
                              <th>1</th>
                              <th>Total</th>
                            </thead>
                            <tbody>
                              <td><input type="text" class="form-control" placeholder="5" id="ec2000_in" value={ec2000_in} onChange={updateec2000_in} />
                              <code>{ec2000_in_er}</code></td>
                              <td><input type="text" class="form-control" placeholder="3" id="ec500_in" value={ec500_in} onChange={updateec500_in} />
                              <code>{ec500_in_er}</code></td>
                              <td><input type="text" class="form-control" placeholder="2" id="ec200_in" value={ec200_in} onChange={updateec200_in} />
                              <code>{ec200_in_er}</code></td>
                              <td><input type="text" class="form-control" placeholder="2" id="ec100_in" value={ec100_in} onChange={updateec100_in} />
                              <code>{ec100_in_er}</code></td>
                              <td><input type="text" class="form-control" placeholder="1" id="ec50_in" value={ec50_in} onChange={updateec50_in} />
                              <code>{ec50_in_er}</code></td>
                              <td><input type="text" class="form-control" placeholder="3" id="ec20_in" value={ec20_in} onChange={updateec20_in} />
                              <code>{ec20_in_er}</code></td>
                              <td><input type="text" class="form-control" placeholder="3" id="ec10_in" value={ec10_in} onChange={updateec10_in} />
                              <code>{ec10_in_er}</code></td>
                              <td><input type="text" class="form-control" placeholder="5" id="ec5_in" value={ec5_in} onChange={updateec5_in} />
                              <code>{ec5_in_er}</code></td>
                              <td><input type="text" class="form-control" placeholder="3" id="ec2_in" value={ec2_in} onChange={updateec2_in} />
                              <code>{ec2_in_er}</code></td>
                              <td><input type="text" class="form-control" placeholder="3" id="ec1_in" value={ec1_in} onChange={updateec1_in} />
                              <code>{ec1_in_er}</code></td>
                              <td><input type="text" class="form-control" placeholder="30" id="ccount_in" value={ccount_in} onChange={updateccount_in} />
                              <code>{ccount_in_er}</code></td>
                            </tbody>
                          </table>
                        </div>
                        {/* CURRENCY ENTRY TABLE END */}
                        {/* CURRENCY RETURN TABLE START */}
                          <div class="row">
                          <h6  style={{textAlign:"left", marginTop:"2rem"}}>Change Return</h6>
                          <table class="table table-bordered">
                            <thead>
                              <th>2000</th>
                              <th>500</th>
                              <th>200</th>
                              <th>100</th>
                              <th>50</th>
                              <th>20</th>
                              <th>10</th>
                              <th>5</th>
                              <th>2</th>
                              <th>1</th>
                              <th>Total</th>
                            </thead>
                            <tbody>
                              <td><input type="text" class="form-control" placeholder="5" id="ec2000_out" value={ec2000_out} onChange={updateec2000_out} />
                              <code>{ec2000_out_er}</code></td>
                              <td><input type="text" class="form-control" placeholder="3" id="ec500_out" value={ec500_out} onChange={updateec500_out} />
                              <code>{ec500_out_er}</code></td>
                              <td><input type="text" class="form-control" placeholder="2" id="ec200_out" value={ec200_out} onChange={updateec200_out} />
                              <code>{ec200_out_er}</code></td>
                              <td><input type="text" class="form-control" placeholder="2" id="ec100_out" value={ec100_out} onChange={updateec100_out} />
                              <code>{ec100_out_er}</code></td>
                              <td><input type="text" class="form-control" placeholder="1" id="ec50_out" value={ec50_out} onChange={updateec50_out} />
                              <code>{ec50_out_er}</code></td>
                              <td><input type="text" class="form-control" placeholder="3" id="ec20_out" value={ec20_out} onChange={updateec20_out} />
                              <code>{ec20_out_er}</code></td>
                              <td><input type="text" class="form-control" placeholder="3" id="ec10_out" value={ec10_out} onChange={updateec10_out} />
                              <code>{ec10_out_er}</code></td>
                              <td><input type="text" class="form-control" placeholder="5" id="ec5_out" value={ec5_out} onChange={updateec5_out} />
                              <code>{ec5_out_er}</code></td>
                              <td><input type="text" class="form-control" placeholder="3" id="ec2_out" value={ec2_out} onChange={updateec2_out} />
                              <code>{ec2_out_er}</code></td>
                              <td><input type="text" class="form-control" placeholder="3" id="ec1_out" value={ec1_out} onChange={updateec1_out} />
                              <code>{ec1_out_er}</code></td>
                              <td><input type="text" class="form-control" placeholder="30" id="ccount_out" value={ccount_out} onChange={updateccount_out} />
                              <code>{ccount_out_er}</code></td>
                            </tbody>
                          </table>
                        </div>
                        {/* CURRENCY RETURN TABLE END */}

                        {/* CURRENCY TOTAL START */}
                       <div class="row">
                      {/*}  <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Currency Entry Count</label>
                            <br/><p>{ccount_in}</p>
                          </div>
                        </div>
                         <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Currency Change Count</label>
                            <br/><p>{ccount_out}</p>
                          </div>
                        </div> */}
                      {/*}  <div class="col-md-3">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Currency Entry Count</label>
                            <br/><p>{ccount_in}</p>
                          </div>
                        </div>  */}
                         <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Amount Recieved</label>
                            <br/><p>{ctotal_in}</p>
                          </div>
                        </div> 
                          <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Amount Returned</label>
                            <br/><p>{ctotal_out}</p>
                          </div>
                        </div> 
                        </div> 
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Net Amount</label>
                            <br/><p>{camount}</p>
                          </div>
                        </div> 
                        {/* CURRENCY TOTAL END */}
                      
                        <button class="btn btn-lg btn-success" style={{fontWeight:"bold"}} onClick={edit_transaction}>Submit</button>
                      
                       
    
                     
                   
                    </div>
                  </div>
                </div>

                </div>
          {/*} content-wrapper ends */}
          {/*} partial:partials/_footer.html */}
       {/*}   <footer className="footer">
            <div className="d-sm-flex justify-content-center justify-content-sm-between">
              <span className="text-muted text-center text-sm-left d-block d-sm-inline-block">Copyright © 2021 <a href="https://www.bootstrapdash.com/" target="_blank">BootstrapDash</a>. All rights reserved.</span>
              <span className="float-none float-sm-right d-block mt-1 mt-sm-0 text-center">Hand-crafted & made with <i className="mdi mdi-heart text-danger"></i></span>
            </div>
          </footer> */}
          {/*} partial */}
        </div>
        {/*} main-panel ends */}
      </div>
      {/*} page-body-wrapper ends */}
    </div>
    {/*} container-scroller */}
    {/*} plugins:js */}
    <script src="panel/assets/vendors/js/vendor.bundle.base.js"></script>
    {/*} endinject */}
    {/*} Plugin js for this page */}
    <script src="panel/assets/vendors/jquery-bar-rating/jquery.barrating.min.js"></script>
    <script src="panel/assets/vendors/chart.js/Chart.min.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.resize.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.categories.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.fillbetween.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.stack.js"></script>
    <script src="panel/assets/js/jquery.cookie.js" type="text/javascript"></script>
    {/*} End plugin js for this page */}
    {/*} inject:js */}
    <script src="panel/assets/js/off-canvas.js"></script>
    <script src="panel/assets/js/hoverable-collapse.js"></script>
    <script src="panel/assets/js/misc.js"></script>
    <script src="panel/assets/js/settings.js"></script>
    <script src="panel/assets/js/todolist.js"></script>
    {/*} endinject */}
    {/*} Custom js for this page */}
    <script src="panel/assets/js/dashboard.js"></script>
    {/*} End custom js for this page */}
  </body>
</html>
    </>

);
}
//}

export default Employee_edit_cash;